// @flow
import React, { Component, Fragment } from 'react';
import type { State } from 'store';
import { connect } from 'react-redux';
import ProductComments from 'components/product/ProductComments/ProductComments';
import ProductCommentInput from 'components/product/ProductCommentInput/ProductCommentInput';
import { ProductsActions } from 'store/actionCreators';
import type { Comment, RemoveComment, SubCommentsMap } from 'store/modules/products';
import QuestionModal from 'components/common/QuestionModal';
import { type ContextRouter, withRouter } from 'react-router-dom';

type Props = {
  productId: ?string,
  comments: ?(Comment[]),
  subCommentsMap: SubCommentsMap,
  shouldCancel: boolean,
  logged: boolean,
  loading: boolean,
  username: ?string,
  removeComment: RemoveComment,
  commentsCount: ?number,
} & ContextRouter;

class ProductCommentsContainer extends Component<Props> {
  onOpenRemove = (payload: { commentId: string, parentId: ?string }) => {
    ProductsActions.openCommentRemove(payload);
  };

  onCancelRemove = () => {
    ProductsActions.cancelCommentRemove();
  };

  onConfirmRemove = () => {
    const { productId, removeComment } = this.props;
    if (!productId || !removeComment.commentId) return;
    ProductsActions.removeComment({
      productId,
      commentId: removeComment.commentId,
    });
  };

  onEditComment = ({
    commentId,
    parentId,
    text,
  }: {
    commentId: string,
    parentId: ?string,
    text: string,
  }) => {
    const { productId } = this.props;
    if (!productId) return Promise.resolve();
    return ProductsActions.editComment({
      productId,
      commentId,
      text,
      parentId,
    });
  };

  onWriteComment = async (text: string, replyTo: ?string, parentId?: ?string) => {
    const { productId } = this.props;
    if (!productId) return Promise.resolve();
    let comment = null;
    try {
      comment = await ProductsActions.writeComment({
        productId,
        text,
        replyTo,
      });
      if (replyTo) {
        await this.onReadReplies(replyTo, parentId);
      } else {
        await ProductsActions.readComments({ productId });
      }
    } catch (e) {
      console.log(e);
    }
    return comment;
  };

  initialize = async () => {
    const { productId, shouldCancel } = this.props;
    if (!productId) return;
    try {
      if (shouldCancel) return;
      await ProductsActions.readComments({ productId });
    } catch (e) {
      console.log(e);
    }
  };

  componentDidMount() {
    this.initialize();
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.productId !== this.props.productId) {
      this.initialize();
    }
  }

  onReadReplies = (commentId: string, parentId?: ?string) => {
    const { productId } = this.props;
    if (!productId) return Promise.resolve(null);
    return ProductsActions.readSubComments({
      productId,
      commentId,
      parentId,
    });
  };

  render() {
    const {
      comments,
      subCommentsMap,
      logged,
      loading,
      username,
      removeComment,
      commentsCount,
    } = this.props;

    if (loading) return null;

    return (
      <Fragment>
        <ProductComments
          logged={logged}
          commentInput={logged && <ProductCommentInput onWriteComment={this.onWriteComment} />}
          comments={comments}
          subCommentsMap={subCommentsMap}
          onReply={this.onWriteComment}
          onReadReplies={this.onReadReplies}
          username={username}
          onOpenRemove={this.onOpenRemove}
          onEditComment={this.onEditComment}
          commentsCount={commentsCount || 0}
          currentPath={this.props.location.pathname}
        />
        <QuestionModal
          title="상품문의 삭제"
          description="이 상품문의를 삭제하시겠습니까?"
          confirmText="삭제하기"
          onConfirm={this.onConfirmRemove}
          onCancel={this.onCancelRemove}
          open={removeComment.visible}
        />
      </Fragment>
    );
  }
}

export default connect(
  (state: State) => ({
    logged: !!state.user.user,
    productId: state.products.product && state.products.product.id,
    comments: state.products.comments,
    subCommentsMap: state.products.subCommentsMap,
    shouldCancel: state.common.ssr && !state.common.router.altered,
    loading: !state.products.product || state.pender.pending['products/READ_COMMENTS'],
    username: state.user.user && state.user.user.username,
    removeComment: state.products.removeComment,
    commentsCount: state.products.product && state.products.product.comments_count,
  }),
  () => ({}),
)(withRouter(ProductCommentsContainer));



// WEBPACK FOOTER //
// ./src/containers/product/ProductCommentsContainer.js